export default __webpack_public_path__ + "static/media/health.497cc930.png";